import PropTypes from 'prop-types';

import Modal from './Modal';

import { GAME_TITLE } from '../../constants/strings';

import style from '../../styles/Modal.module.scss';

const AboutModal = ({ modalRef }) => {
  return (
    <Modal id="info-modal" title={`About ${GAME_TITLE}`} modalRef={modalRef}>
      <div className={style['inner-wrapper']}>
        <div className={style['main-content']}>
          <p>
            Congratulations, you&apos;ve found Bardle! The whole Internet at
            your disposal, yet here you are. Bless you.
          </p>
          <p>
            Bardle is a daily word game that was heavily inspired (like so many)
            by those twin bastions of modern excellence: Josh Wardle&apos;s{' '}
            <a href="https://www.nytimes.com/games/wordle/index.html">Wordle</a>
            , and{' '}
            <a href="https://en.wikipedia.org/wiki/William_Shakespeare">
              William Shakespeare
            </a>
            .
          </p>
          <p>
            It was mixed, cooked, baked and served up hot and ready by me,
            Daniel. If you just ❤️ it and want to shower me with praise, please
            consider <a href="https://ko-fi.com/bogod">buying me a coffee</a>.
          </p>
          <p>
            Also, shout out to my dear old Dad for coming up with the name. Let&apos;s face it, there&apos;s no better name for this game.
          </p>
          <p>
            So that&apos;s it really. If you want, you can{' '}
            <a href="https://twitter.com/bogod">follow me on Twitter</a>. Or
            better yet, <a href="https://twitter.com/BogodDavid">follow Dad</a>.
            He&apos;d absolutely love it.
          </p>
          <p>Fare thee well!</p>
          <p>
            PS - if you like Wordle, you might have a use for{' '}
            <a href="https://wordlemonkey.bogod.dev">Wordle Monkey</a>. Just
            saying.
          </p>
        </div>
      </div>
    </Modal>
  );
};

AboutModal.propTypes = {
  modalRef: PropTypes.object.isRequired,
};

export default AboutModal;
